import styled from 'styled-components'
import { mobile } from 'styles/responsive'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 40px;

    ${mobile(`
        padding: 0 15px;
        overflow: hidden;
    `)}

    > * + * {
        margin-top: 40px;
    }
`
